import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export default function Resolution({
  value,
  onChange,
}: {
  value: string;
  onChange: (resolution: string) => void;
}) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select resolution" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="Match Source">Match Source</SelectItem>
        <SelectItem value="720p (HD)">720p (HD)</SelectItem>
        <SelectItem value="1080p (Full HD)">1080p (Full HD)</SelectItem>
        <SelectItem value="2160p (4K)">2160p (4K)</SelectItem>
      </SelectContent>
    </Select>
  );
}
